






import { defineComponent, ref } from '@vue/composition-api';

/**
 * Form Filter component
 */
export default defineComponent({
	props: {
		inputPlaceholder: {
			type: String,
			default: 'Formulare filtern',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const formFilter = ref<HTMLElement | null>(null);

		function toggleItemVisiblity(title: HTMLHeadingElement, regex: RegExp) {
			if (title.parentElement === null || title.parentElement.parentElement === null) {
				return;
			}
			if (title.innerText.match(regex)) {
				title.parentElement.parentElement.classList.remove('hidden');
			} else {
				title.parentElement.parentElement.classList.add('hidden');
			}
		}

		function toggleSectionTitleVisibility(sectionTitle: HTMLHeadingElement) {
			const formsInSection = Array.from(sectionTitle.nextElementSibling?.children || []);
			const hideSectionTitle = formsInSection.every((form) => form.classList.contains('hidden'));
			if (hideSectionTitle) {
				sectionTitle.classList.add('hidden');
			} else {
				sectionTitle.classList.remove('hidden');
			}
		}

		function toggleMainTitleVisibility(mainTitle: HTMLHeadingElement) {
			const formTitles = Array.from(
				mainTitle.nextElementSibling?.querySelectorAll<HTMLHeadingElement>('h3.font-bold') || [],
			);
			const hideMainTitle = formTitles.every((title) =>
				title.parentElement?.parentElement?.classList.contains('hidden'),
			);

			if (hideMainTitle) {
				mainTitle.classList.add('hidden');
				mainTitle.nextElementSibling?.classList.add('hidden');
			} else {
				mainTitle.classList.remove('hidden');
				mainTitle.nextElementSibling?.classList.remove('hidden');
			}
		}

		function onInput(event: KeyboardEvent) {
			const target = event.target as HTMLInputElement;
			if (formFilter.value === null) {
				return;
			}
			const formTitles = Array.from(formFilter.value.querySelectorAll<HTMLHeadingElement>('h3.font-bold'));
			const sectionTitles = Array.from(formFilter.value.querySelectorAll<HTMLHeadingElement>('h3.text-primary'));
			const mainTitles = Array.from(formFilter.value.querySelectorAll<HTMLHeadingElement>('h2.text-primary'));
			const regex = new RegExp(target.value, 'i');
			formTitles.map((formTitle) => toggleItemVisiblity(formTitle, regex));
			sectionTitles.map((sectionTitle) => toggleSectionTitleVisibility(sectionTitle));
			mainTitles.map((mainTitle) => toggleMainTitleVisibility(mainTitle));
		}

		return { onInput, formFilter };
	},
});
